import React, { useEffect } from 'react';
import styles from './ModalTask.module.scss';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { TELEGRAM_CTA_URL } from '../../constants/cta';
import { trackGoal } from '../../analytics/metrika';

const ModalTask = ({ onClose, activeTask, headHeight }) => {
  const { modalTask } = useSelector((state) => state.app);

  useEffect(() => {
    if (!modalTask) return undefined;

    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    };
  }, [modalTask]);

  const openTelegram = () => {
    trackGoal('cta_telegram_click', {
      source: 'task_modal',
      serviceId: activeTask?.id || 'unknown',
      serviceName: activeTask?.name || 'unknown',
    });

    window.open(TELEGRAM_CTA_URL, '_blank');
  };

  return (
    <div
      className={clsx(styles.overlay, modalTask && styles.overlayActive)}
      style={{
        '--task-accent-color': activeTask?.hoverColor || '#16a34a',
        '--task-head-height': `${headHeight || 100}px`,
      }}
      onClick={() => {
        onClose();
      }}>
      <div
        className={clsx(styles.modal)}
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <div className={clsx(styles.topBar)}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => {
              onClose();
            }}
            aria-label="Закрыть окно услуги">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.7 5.3a1 1 0 0 0-1.4 1.4L10.6 12l-5.3 5.3a1 1 0 1 0 1.4 1.4l5.3-5.3l5.3 5.3a1 1 0 1 0 1.4-1.4L13.4 12l5.3-5.3a1 1 0 0 0-1.4-1.4L12 10.6z" />
            </svg>
          </button>
        </div>
        <div className={clsx(styles.content)}>
          <div className={clsx(styles.text)}>{activeTask?.shortDesc}</div>
          <div className={clsx(styles.meta)}>
            <span>{activeTask?.timeline}</span>
            <span>{activeTask?.priceRange}</span>
          </div>
          <div className={clsx(styles.lists)}>
            <div className={clsx(styles.listWrap)}>
              <div className={clsx(styles.listTitle, styles.listTitleLeft)}>
                <b>Кому подойдет</b>
              </div>
              <div className={clsx(styles.list, styles.listLeft)}>
                {activeTask?.forWhom?.map((item) => (
                  <div className={clsx(styles.listItem)} key={item}>
                    <div className={clsx(styles.itemIcon)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path
                          fill="rgba(104, 100, 237, 1)"
                          d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
                        />
                      </svg>
                    </div>
                    <div className={clsx(styles.itemText)}>{item}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className={clsx(styles.listWrap)}>
              <div className={clsx(styles.listTitle, styles.listTitleRight)}>
                <b>Что получите на выходе</b>
              </div>
              <div className={clsx(styles.list, styles.listRight)}>
                {activeTask?.deliverables?.map((item) => (
                  <div className={clsx(styles.listItem)} key={item}>
                    <div className={clsx(styles.itemIconRight)}>🚀</div>
                    <div className={clsx(styles.itemText)}>{item}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <button
            className={clsx(styles.cta)}
            onClick={openTelegram}
            data-metrika-label={activeTask?.ctaText || 'Обсудить задачу в Telegram'}
            data-metrika-section="task-modal">
            {activeTask?.ctaText || 'Обсудить задачу в Telegram'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalTask;
